export default __webpack_public_path__ + "static/Sohne-HalbfettKursiv-e9082f4161b85b6d1116713ae47539ce.woff2";